var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * PackingScanner Component — Scan & Pack into a Selected Package
 */
import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { Form, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import Input from '@fp-suite/core-ui/src/components/Input';
import Button from '@fp-suite/core-ui/src/components/Button';
import Table from '@fp-suite/core-ui/src/components/Table';
import { usePackingState, usePackingActions } from '../../../hooks/packing';
export var PackingScanner = function (_a) {
    var packageSeqId = _a.packageSeqId, boxTypeId = _a.boxTypeId, onClose = _a.onClose, onDelete = _a.onDelete;
    var t = useTranslation().t;
    var qtyForm = Form.useForm()[0];
    var scanInputRef = useRef(null);
    // State
    var _b = useState('quick'), mode = _b[0], setMode = _b[1];
    var _c = useState(''), scanInput = _c[0], setScanInput = _c[1];
    var _d = useState(1), productQty = _d[0], setProductQty = _d[1];
    var _e = useState(1), cartonQty = _e[0], setCartonQty = _e[1];
    var _f = useState(null), scanError = _f[0], setScanError = _f[1];
    // Hooks
    var _g = usePackingState(), packageContentBySeqId = _g.packageContentBySeqId, packageOrderItemsBySeqId = _g.packageOrderItemsBySeqId, shipmentItemDetailList = _g.shipmentItemDetailList, kitComponentProducts = _g.kitComponentProducts, loading = _g.loading;
    var _h = usePackingActions(), handleScanProduct = _h.handleScanProduct, handleResetPackage = _h.handleResetPackage, handleDeletePackage = _h.handleDeletePackage, handleUpdateQuantity = _h.handleUpdateQuantity;
    // const { getPackageInfo } = usePackageManagement()
    // Auto-focus scan input on mount
    useEffect(function () {
        var _a;
        (_a = scanInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    // Package content for the current package
    var packageContent = useMemo(function () { return packageContentBySeqId[packageSeqId] || []; }, [packageContentBySeqId, packageSeqId]);
    var packageOrderItems = useMemo(function () { return packageOrderItemsBySeqId[packageSeqId] || []; }, [packageOrderItemsBySeqId, packageSeqId]);
    var hasItems = packageContent.length > 0;
    // Initialize qty form fields when package order items change
    useEffect(function () {
        var fields = {};
        packageOrderItems.forEach(function (item) {
            fields["Qty_" + item.productId + "_" + item.orderItemSeqId] = item.quantity;
        });
        qtyForm.setFieldsValue(fields);
    }, [packageOrderItems, qtyForm]);
    // Scan submit handler
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, msg;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!scanInput.trim())
                        return [2 /*return*/];
                    setScanError(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleScanProduct({
                            scanId: scanInput,
                            shipmentItemDetailList: shipmentItemDetailList,
                            kitComponentProducts: kitComponentProducts,
                            quantity: productQty,
                            shipmentPackageSeqId: packageSeqId || undefined,
                            shipmentBoxTypeId: boxTypeId,
                            carton: mode === 'bulk' ? cartonQty : undefined
                        })
                        // Reset form on success
                    ];
                case 2:
                    _b.sent();
                    // Reset form on success
                    setScanInput('');
                    setProductQty(1);
                    setCartonQty(1);
                    (_a = scanInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    msg = (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || t('Failed to pack item');
                    setScanError(msg);
                    notification.error({ message: t('Error'), description: msg });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [
        scanInput,
        productQty,
        cartonQty,
        mode,
        packageSeqId,
        boxTypeId,
        shipmentItemDetailList,
        kitComponentProducts,
        handleScanProduct,
        t
    ]);
    // Handle qty update for a package item row
    var onQtyUpdate = useCallback(function (record) { return __awaiter(void 0, void 0, void 0, function () {
        var fieldName, quantity, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fieldName = "Qty_" + record.productId + "_" + record.orderItemSeqId;
                    quantity = parseInt(qtyForm.getFieldValue(fieldName)) || 0;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleUpdateQuantity({
                            shipmentPackageSeqId: packageSeqId,
                            productId: record.productId,
                            quantity: quantity,
                            orderId: record.orderId,
                            orderItemSeqId: record.orderItemSeqId
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    notification.error({
                        message: t('Error'),
                        description: (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) || t('Failed to update quantity')
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [packageSeqId, handleUpdateQuantity, qtyForm, t]);
    // Reset package handler
    var onReset = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, handleResetPackage(packageSeqId)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    notification.error({
                        message: t('Error'),
                        description: (error_3 === null || error_3 === void 0 ? void 0 : error_3.message) || t('Failed to reset package')
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [packageSeqId, handleResetPackage, t]);
    // Delete package handler
    var onDeletePackage = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, handleDeletePackage(packageSeqId)];
                case 1:
                    _a.sent();
                    onDelete();
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    notification.error({
                        message: t('Error'),
                        description: (error_4 === null || error_4 === void 0 ? void 0 : error_4.message) || t('Failed to delete package')
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [packageSeqId, handleDeletePackage, onDelete, t]);
    // Table columns
    var columns = useMemo(function () { return [
        {
            title: t('SKU'),
            dataIndex: 'productSku',
            render: function (_, record) { return record.productSku || record.productUpc || record.productId; }
        },
        {
            title: t('Product'),
            dataIndex: 'productName',
            render: function (name) { return name || ''; }
        },
        {
            title: t('Qty'),
            dataIndex: 'quantity',
            render: function (_, record) {
                var fieldName = "Qty_" + record.productId + "_" + record.orderItemSeqId;
                return (_jsxs("div", __assign({ className: 'flex items-center gap-2' }, { children: [_jsx(Form.Item, __assign({ name: fieldName, noStyle: true }, { children: _jsx(Input, { inputType: 'number', placeholder: '', title: '', onKeyDown: function (e) {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        onQtyUpdate(record);
                                    }
                                } }, void 0) }), void 0), _jsx(Button, { buttonText: t('Update'), paddingX: 'px-2', paddingY: 'py-1', onClick: function () { return onQtyUpdate(record); }, loading: loading.updatePackage }, void 0)] }), void 0));
            }
        }
    ]; }, [t, onQtyUpdate, loading.updatePackage]);
    return (_jsxs("div", __assign({ className: 'space-y-5' }, { children: [_jsxs("div", __assign({ className: 'flex items-center justify-between' }, { children: [_jsxs("h2", __assign({ className: 'text-lg font-bold text-gray-800' }, { children: [t('Add to Package'), " ", _jsx("span", __assign({ className: 'text-primary' }, { children: packageSeqId }), void 0)] }), void 0), hasItems ? (_jsx(Button, { buttonText: t('Reset'), paddingX: 'px-4', paddingY: 'py-2', defaultColor: 'bg-white', classNames: 'border-2 border-red-400 text-red-500 rounded-lg text-sm font-semibold hover:bg-red-50', onClick: onReset, loading: loading.resetPackage }, void 0)) : (_jsx(Button, { buttonText: t('Delete'), paddingX: 'px-4', paddingY: 'py-2', defaultColor: 'bg-red-500', classNames: 'rounded-lg text-sm', onClick: onDeletePackage, loading: loading.deletePackage }, void 0))] }), void 0), _jsxs("div", __assign({ className: 'inline-flex bg-white rounded-lg p-1' }, { children: [_jsx("button", __assign({ className: "px-5 py-2 rounded-md text-sm font-semibold transition-all " + (mode === 'quick'
                            ? 'bg-white text-primary shadow-sm'
                            : 'text-gray-500 hover:text-gray-700'), onClick: function () { return setMode('quick'); } }, { children: t('Quick') }), void 0), _jsx("button", __assign({ className: "px-5 py-2 rounded-md text-sm font-semibold transition-all " + (mode === 'bulk'
                            ? 'bg-white text-primary shadow-sm'
                            : 'text-gray-500 hover:text-gray-700'), onClick: function () { return setMode('bulk'); } }, { children: t('Bulk') }), void 0)] }), void 0), _jsx("div", __assign({ className: 'bg-white rounded-xl border border-blue-100 shadow-sm p-4' }, { children: _jsxs(Form, __assign({ form: qtyForm, onFinish: mode === 'quick' ? handleSubmit : undefined }, { children: [_jsxs("div", __assign({ className: 'mb-4' }, { children: [mode === 'quick' ? (_jsx(Input, { ref: scanInputRef, placeholder: t('Scan SKU / UPC'), title: t('Scan SKU / UPC'), value: scanInput, autoFocus: true, onChange: function (e) {
                                        setScanInput(e.target.value);
                                        setScanError(null);
                                    }, onKeyDown: function (e) {
                                        if (e.key === 'Enter' || e.key === 'Tab') {
                                            e.preventDefault();
                                            handleSubmit();
                                        }
                                    } }, void 0)) : (_jsxs(_Fragment, { children: [_jsx(Input, { ref: scanInputRef, placeholder: t('Scan SKU / UPC'), title: t('Scan SKU / UPC'), value: scanInput, autoFocus: true, onChange: function (e) {
                                                setScanInput(e.target.value);
                                                setScanError(null);
                                            } }, void 0), _jsxs("div", __assign({ className: 'flex gap-3 mt-3' }, { children: [_jsx("div", __assign({ className: 'flex-1' }, { children: _jsx(Input, { placeholder: '', title: t('Product Qty'), inputType: 'number', value: productQty, onChange: function (e) { return setProductQty(parseInt(e.target.value) || 1); } }, void 0) }), void 0), _jsx("div", __assign({ className: 'flex-1' }, { children: _jsx(Input, { placeholder: '', title: t('Carton Qty'), inputType: 'number', value: cartonQty, onChange: function (e) { return setCartonQty(parseInt(e.target.value) || 1); }, onKeyDown: function (e) {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                handleSubmit();
                                                            }
                                                        } }, void 0) }), void 0)] }), void 0)] }, void 0)), scanError && (_jsx("p", __assign({ className: 'text-red-500 text-sm mt-2 bg-red-50 px-3 py-1.5 rounded-md' }, { children: scanError }), void 0))] }), void 0), _jsxs("div", __assign({ className: 'flex gap-3' }, { children: [_jsx(Button, { buttonText: t('Close Package'), paddingX: 'px-5', paddingY: 'py-2.5', defaultColor: 'bg-gray-600', classNames: 'rounded-lg text-sm', onClick: onClose }, void 0), _jsx(Button, { buttonText: t('Submit'), paddingX: 'px-5', paddingY: 'py-2.5', classNames: 'rounded-lg text-sm', onClick: handleSubmit, loading: loading.packItem }, void 0)] }), void 0)] }), void 0) }), void 0), _jsxs("div", __assign({ className: 'bg-white rounded-xl border border-blue-100 shadow-sm p-4' }, { children: [_jsx("h3", __assign({ className: 'text-base font-bold text-gray-700 mb-3' }, { children: t('Items') }), void 0), _jsx(Form, __assign({ form: qtyForm }, { children: _jsx(Table, { columns: columns, dataSource: packageOrderItems, isPaginated: packageOrderItems.length > 10 }, packageSeqId) }), void 0)] }), void 0)] }), void 0));
};
export default PackingScanner;
